import React from "react";

const Portfoliosdetailstopsection = ({
  logoimage,
  title,
  description,
  buttontext,
  buttonlink,
  image,
  equalColumns = false,
}) => {
  const leftColumnClass = equalColumns ? "col-lg-6" : "col-lg-5";
  const rightColumnClass = equalColumns ? "col-lg-6" : "col-lg-7";

  return (
    <section className="hero-section-main okbaju rounded-0 d-flex align-items-center">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className={`${leftColumnClass} portfolio-hero-content`}>
            <div className="portfolio-hero-logo mb-2">
              <img src={logoimage} alt="logo" className="portfolio-logo" />
            </div>

            <h1 className="portfolio-hero-main-title">{title}</h1>

            <p className="portfolio-hero-description">{description}</p>

            <a href={buttonlink} className="btn btn-orange">
              {buttontext}
            </a>
          </div> 

          {/* Right Image */}
          <div className={`${rightColumnClass} hero-image text-center mt-5 mt-lg-0`}>
            <div className="portfolio-device-mockups portfolio-details-img">
              <img src={image} alt={title} className="portfolio-hero-img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfoliosdetailstopsection;
